module.exports = __webpack_public_path__ + "media/slider/Banner-4-a4c4dade.jpg";